import { render, staticRenderFns } from "./treatment-component.vue?vue&type=template&id=642b5bb3&scoped=true&lang=pug"
import script from "./treatment-component.js?vue&type=script&lang=js&external"
export * from "./treatment-component.js?vue&type=script&lang=js&external"
import style0 from "./treatment-component.vue?vue&type=style&index=0&id=642b5bb3&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "642b5bb3",
  null
  
)

export default component.exports